import React, { useEffect, useRef, useState } from "react";
import researchlogo from "../../../../assets/images/ChatGPT Image Jan 2, 2026, 04_02_38 PM (1).png";
import backgroundImage from "../../../../assets/images/whitePaperBg.jpg";
import globeImage from "../../../../assets/images/whitePaperGlobe.png";
import { saveWhitepaperReportLayout } from "../newsletterAgentComponents/action";
import { API_PROD_URL } from "src/utils/axios";
import { detectDataStructure, formatChartValue, parseChartValue } from "./Utiils";
import { useAppDispatch } from "src/hooks/redux";
import { generateWhitepaperImage } from "../action";

const Report = () => {
  const [reportData, setReportData] = useState<any>(null);
  const [base64Images, setBase64Images] = useState<{
    research: string;
    background: string;
    globe: string;
  }>({
    research: '',
    background: '',
    globe: ''
  });

  const dispatch = useAppDispatch();

  // Track which image is being enhanced
  const [enhancingImageKey, setEnhancingImageKey] = useState<string | null>(null);

  // Context menu state
  const [contextMenu, setContextMenu] = useState<{
    show: boolean;
    x: number;
    y: number;
    sectionIndex: number;
    imageIndex: number;
    imageUrl: string;
  } | null>(null);

  const [isEditMode, setIsEditMode] = useState(false);
  const [coverImage, setCoverImage] = useState("https://leptonsoftware.com/wp-content/uploads/2020/11/ss.jpg");
  const [enterpriseLabel, setEnterpriseLabel] = useState("ENTERPRISE");
  const [readyForNextLabel, setReadyForNextLabel] = useState("Ready for Next");
  const [footerReadyForNextLabel, setFooterReadyForNextLabel] = useState("Ready for Next");
  const [tocTitle, setTocTitle] = useState("TABLE OF CONTENTS");
  const [collaborationText, setCollaborationText] = useState("Produced in collaboration with");
  const [footerText, setFooterText] = useState(
    "Broadridge Financial Solutions (NYSE: BR) is a global technology leader with trusted expertise and transformative technology, helping clients and the financial services industry operate, innovate, and grow. We power investing, governance, and communications for our clients - driving operational resiliency, elevating business performance, and transforming investor experiences. For more information, please visit Broadridge.com."
  );

  // Drag and drop state
  const [draggedItem, setDraggedItem] = useState<{
    type: 'paragraph' | 'section' | 'list' | 'chart';
    sectionIndex: number;
    itemIndex?: number;
    listIndex?: number;
    chartIndex?: number;
  } | null>(null);
  const [dragOverItem, setDragOverItem] = useState<{
    sectionIndex: number;
    itemIndex?: number;
  } | null>(null);



  // Convert imported images to base64
  useEffect(() => {
  const convertImagesToBase64 = async () => {
    try {
        const toBase64 = async (url: string): Promise<string> => {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        };

      const [researchBase64, bgBase64, globeBase64] = await Promise.all([
        toBase64(researchlogo),
        toBase64(backgroundImage),
        toBase64(globeImage)
      ]);

      setBase64Images({
        research: researchBase64,
        background: bgBase64,
        globe: globeBase64
      });
      } catch (error) {
        console.error('Error converting images to base64:', error);
    }
  };

  convertImagesToBase64();
}, []);

  useEffect(() => {
    const stored = sessionStorage.getItem('whitepaper_report');
    if (stored) {
      const data = JSON.parse(stored);
      setReportData(data);
      
      // Initialize footer text if exists
      if (data?.response?.footerText) {
        setFooterText(data.response.footerText);
      }
    }
  }, []);

  // Handle right-click on image
    const handleImageRightClick = (
      e: React.MouseEvent,
      sectionIndex: number,
      imageIndex: number,
      imageUrl: string
    ) => {
      e.preventDefault(); // Prevent default browser context menu
      
      setContextMenu({
        show: true,
        x: e.clientX,
        y: e.clientY,
        sectionIndex,
        imageIndex,
        imageUrl
      });
    };

   function fileToBase64(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          if (typeof reader.result === 'string') {
            resolve(reader.result.split(',')[1]);
          } else {
            reject(new Error('Invalid file'));
          }
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }


    



// Handle enhance image
    const handleEnhanceImage = async () => {
  if (!contextMenu) return;

  const { sectionIndex, imageIndex, imageUrl } = contextMenu;
  const key = `${sectionIndex}-${imageIndex}`;

  setContextMenu(null);
  setEnhancingImageKey(key);

  try {
    const payload: any = {
      context: `Image from section: ${
        reportData?.response?.sections[sectionIndex]?.heading || 'Whitepaper'
      }`,
      prompt:'Enhance this image to high quality, improve clarity, sharpness, and overall visual appeal.',
      additional_instructions: 'Maintain original content and composition.',
      preference: 'gemini',
    };

    const imageSource: string | File = imageUrl;

    if (typeof imageSource === 'string') {
      payload.image_url = imageSource;
    } else {
      payload.base_image = await fileToBase64(imageSource);
    }

    const result = await dispatch(
      generateWhitepaperImage(payload)
    ).unwrap();

     if (result?.image_url) 
      {setReportData((prev: any) => 
        { const updated = { ...prev }; 
          updated.response.sections[sectionIndex].images[imageIndex].file_url = result.image_url; 
           return updated; 
        });
      }


  } catch (error) {
    console.error('Enhancement failed:', error);
  } finally {
    setEnhancingImageKey(null);
  }
};

  const pageStyle: React.CSSProperties = {
    width: 794,
    minHeight: 1123,
    backgroundColor: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    border: "none",
    verticalAlign: "top",
    breakAfter: "page",
    pageBreakAfter: "always",
    boxShadow: "0 0 10px rgba(0,0,0,.15)",
    marginBottom: "35px",
  };

  const emailLayoutRef = useRef<HTMLDivElement | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle image upload and convert to base64
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, callback: (base64: string) => void) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file');
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleConfirmLayout = async () => {
    setIsSubmitting(true);
    if (!emailLayoutRef.current) return;

    // Clone the content to manipulate
    const clonedContent = emailLayoutRef.current.cloneNode(true) as HTMLElement;

    // Remove all contentEditable attributes
    const editableElements = clonedContent.querySelectorAll('[contenteditable="true"]');
    editableElements.forEach((el) => {
      el.removeAttribute('contenteditable');
    });

    // Remove all edit mode buttons/overlays
    const editButtons = clonedContent.querySelectorAll('.edit-overlay, .edit-button, .insert-button, .delete-button, .add-section-btn, .add-section-container, .action-buttons, .drag-handle');
    editButtons.forEach((btn) => btn.remove());

    // Remove outline styles
    const styledElements = clonedContent.querySelectorAll('[style*="outline"]');
    styledElements.forEach((el: any) => {
      if (el.style) {
        el.style.outline = 'none';
      }
    });

    const rawHtml = clonedContent.innerHTML;

    try {
      const ans = await saveWhitepaperReportLayout(reportData.userId, reportData.threadId, rawHtml);
      if (ans?.status === "success") {
        setIsSuccess(true);
        setIsEditMode(false);
      } else {
        setError("Failed to save data");
      }
    } catch (error) {
      console.error("Failed to save email layout", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Chart rendering function
  const renderChart = (chart: any, sectionIndex: number, chartIndex: number) => {
    const { title, description, type, data } = chart;
    
    // Helper function to generate simple SVG charts
    const generateChartSVG = () => {
      if (type === 'line') {
        return renderLineChart(data, title);
      } else if (type === 'pie') {
        return renderPieChart(data, title);
      } else if (type === 'bar') {
        return renderBarChart(data, title);
      }
      return null;
    };

    return (
      <div 
        key={`chart-${chartIndex}`}
        draggable={isEditMode}
        onDragStart={(e) => handleDragStart(e, 'chart', sectionIndex, undefined, undefined, chartIndex)}
        onDragEnd={handleDragEnd}
        onDragOver={(e) => handleDragOver(e, sectionIndex, chartIndex)}
        onDrop={(e) => handleDrop(e, sectionIndex, chartIndex)}
        style={{ 
          position: 'relative', 
          marginBottom: '24px',
          breakInside: 'avoid',
          padding: '16px',
          borderRadius: '8px',
          backgroundColor: '#f9fafb',
          cursor: isEditMode ? 'move' : 'default',
          border: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === chartIndex ? '3px dashed #3b82f6' : '1px solid #e5e7eb',
        }}
      >
        {isEditMode && (
          <div className="action-buttons drag-handle" style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            display: 'flex',
            gap: '5px',
            zIndex: 5
          }}>
            <span style={{
              cursor: 'move',
              fontSize: '14px',
              color: '#6366f1',
              padding: '4px 8px',
              background: '#e0e7ff',
              borderRadius: '4px',
              fontWeight: 600
            }}>
              ⋮⋮
            </span>
            <button
              className="delete-button"
              onClick={() => deleteChart(sectionIndex, chartIndex)}
              style={{
                background: '#dc2626',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                fontSize: '11px',
                cursor: 'pointer'
              }}
            >
              🗑️
            </button>
          </div>
        )}

        <div
          contentEditable={isEditMode}
          suppressContentEditableWarning
          onBlur={(e) => handleChartTitleChange(e, sectionIndex, chartIndex)}
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#1e40af",
            marginBottom: "8px",
            outline: isEditMode ? '2px dashed #f97316' : 'none',
            padding: isEditMode ? '4px' : '0',
            cursor: isEditMode ? 'text' : 'default'
          }}
        >
          {title}
        </div>

        {description && (
          <div
            contentEditable={isEditMode}
            suppressContentEditableWarning
            onBlur={(e) => handleChartDescriptionChange(e, sectionIndex, chartIndex)}
            style={{
              fontSize: "13px",
              color: "#6b7280",
              marginBottom: "16px",
              outline: isEditMode ? '2px dashed #f97316' : 'none',
              padding: isEditMode ? '4px' : '0',
              cursor: isEditMode ? 'text' : 'default'
            }}
          >
            {description}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {generateChartSVG()}
        </div>
      </div>
    );
  };

  const renderBarChart = (data: any, title: string) => {
  const width = 600;
  const height = 300;
  const padding = 60;
  const structure = detectDataStructure(data);
  
  if (structure === 'nested-categories') {
    // Handle: { "In-house": { "Setup": "500K" }, "Outsourced": { "Setup": "200K" } }
    const categories = Object.keys(data); // ["In-house", "Outsourced CIO"]
    const subCategories = Object.keys(Object.values(data)[0] as any); // ["Initial Setup Cost", "Annual Maintenance"]
    
    const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6'];
    const groupWidth = (width - 2 * padding) / subCategories.length;
    const barWidth = groupWidth / (categories.length + 1);
    
    // Find max value for scaling
    const allValues = categories.flatMap(cat => 
      subCategories.map(subCat => parseChartValue((data[cat] as any)[subCat]))
    );
    const maxValue = Math.max(...allValues, 1);
    
    return (
      <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
        <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
        
        {/* Draw bars */}
        {subCategories.map((subCat, subIndex) => {
          return categories.map((cat, catIndex) => {
            const rawValue = (data[cat] as any)[subCat];
            const value = parseChartValue(rawValue);
            
            const x = padding + (subIndex * groupWidth) + (catIndex * barWidth) + barWidth * 0.5;
            const barHeight = (value / maxValue) * (height - 2 * padding);
            const y = height - padding - barHeight;
            
            return (
              <g key={`${subCat}-${cat}`}>
                <rect
                  x={x}
                  y={y}
                  width={barWidth * 0.9}
                  height={barHeight}
                  fill={colors[catIndex % colors.length]}
                />
                <text 
                  x={x + barWidth * 0.45} 
                  y={y - 5} 
                  textAnchor="middle" 
                  fontSize="10"
                  fontWeight="600"
                >
                  {formatChartValue(rawValue)}
                </text>
              </g>
            );
          });
        })}
        
        {/* X-axis labels (subcategories) */}
        {subCategories.map((subCat, subIndex) => {
          const x = padding + (subIndex * groupWidth) + groupWidth / 2;
          return (
            <text 
              key={subCat} 
              x={x} 
              y={height - padding + 20} 
              textAnchor="middle" 
              fontSize="10"
            >
              {subCat.length > 15 ? subCat.substring(0, 15) + '...' : subCat}
            </text>
          );
        })}
        
        {/* Legend */}
        {categories.map((cat, catIndex) => (
          <g key={`legend-${cat}`}>
            <rect
              x={width - 150}
              y={40 + catIndex * 20}
              width={12}
              height={12}
              fill={colors[catIndex % colors.length]}
            />
            <text
              x={width - 135}
              y={40 + catIndex * 20 + 10}
              fontSize="11"
              fill="#333"
            >
              {cat}
            </text>
          </g>
        ))}
        
        {/* Axes */}
        <line x1={padding} y1={height-padding} x2={width-padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
        <line x1={padding} y1={padding} x2={padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
      </svg>
    );
  }
  
  // Handle simple or nested-timeseries structures (existing code)
  const entries = Object.entries(data).map(([key, value]) => [
    key,
    parseChartValue(value)
  ]) as [string, number][];
  
  const maxValue = Math.max(...entries.map(([_, v]) => v), 1);
  const barWidth = (width - 2*padding) / entries.length * 0.8;
  const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6'];

  return (
    <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
      <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
      
      {entries.map(([label, value], index) => {
        const x = padding + (index * (width - 2*padding) / entries.length);
        const barHeight = (value / maxValue) * (height - 2*padding);
        const y = height - padding - barHeight;
        const originalValue = data[label];
        
        return (
          <g key={label}>
            <rect
              x={x}
              y={y}
              width={barWidth}
              height={barHeight}
              fill={colors[index % colors.length]}
            />
            <text x={x + barWidth/2} y={y-5} textAnchor="middle" fontSize="11">
              {formatChartValue(originalValue)}
            </text>
            <text x={x + barWidth/2} y={height-padding+20} textAnchor="middle" fontSize="11">
              {label}
            </text>
          </g>
        );
      })}
      
      <line x1={padding} y1={height-padding} x2={width-padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
      <line x1={padding} y1={padding} x2={padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
    </svg>
  );
};

// ==========================================
// LINE CHART RENDERER
// ==========================================

const renderLineChart = (data: any, title: string) => {
  const width = 600;
  const height = 300;
  const padding = 60;
  const structure = detectDataStructure(data);
  
  if (structure === 'nested-categories') {
    // For line charts with nested categories, we'll treat categories as series
    // Example: { "In-house": { "Setup": "500K" }, "Outsourced": { "Setup": "200K" } }
    const categories = Object.keys(data);
    const subCategories = Object.keys(Object.values(data)[0] as any);
    
    const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b'];
    
    // Find max value for scaling
    const allValues = categories.flatMap(cat => 
      subCategories.map(subCat => parseChartValue((data[cat] as any)[subCat]))
    );
    const maxValue = Math.max(...allValues, 1);
    
    return (
      <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
        <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
        
        {categories.map((category, idx) => {
          const points = subCategories.map((subCat, i) => {
            const rawValue = (data[category] as any)[subCat];
            const value = parseChartValue(rawValue);
            const x = padding + (i * (width - 2*padding) / (subCategories.length - 1));
            const y = height - padding - ((value / maxValue) * (height - 2*padding));
            return `${x},${y}`;
          }).join(' ');
          
          return (
            <g key={category}>
              <polyline
                points={points}
                fill="none"
                stroke={colors[idx % colors.length]}
                strokeWidth="3"
              />
              {/* Data points and labels */}
              {subCategories.map((subCat, i) => {
                const rawValue = (data[category] as any)[subCat];
                const value = parseChartValue(rawValue);
                const x = padding + (i * (width - 2*padding) / (subCategories.length - 1));
                const y = height - padding - ((value / maxValue) * (height - 2*padding));
                return (
                  <g key={`${category}-${i}`}>
                    <circle cx={x} cy={y} r="4" fill={colors[idx % colors.length]} />
                    <text 
                      x={x} 
                      y={y - 10} 
                      textAnchor="middle" 
                      fontSize="10" 
                      fill={colors[idx % colors.length]}
                    >
                      {formatChartValue(rawValue)}
                    </text>
                  </g>
                );
              })}
              {/* Legend */}
              <text x={width - padding + 10} y={30 + idx * 20} fontSize="11" fill={colors[idx % colors.length]}>
                {category}
              </text>
            </g>
          );
        })}
        
        {/* X-axis labels */}
        {subCategories.map((subCat, i) => {
          const x = padding + (i * (width - 2*padding) / (subCategories.length - 1));
          return (
            <text key={subCat} x={x} y={height-padding+20} textAnchor="middle" fontSize="10">
              {subCat.length > 10 ? subCat.substring(0, 10) + '...' : subCat}
            </text>
          );
        })}
        
        {/* Axes */}
        <line x1={padding} y1={height-padding} x2={width-padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
        <line x1={padding} y1={padding} x2={padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
      </svg>
    );
  }
  
  // Handle nested-timeseries structure
  if (structure === 'nested-timeseries') {
    const years = Object.keys(data);
    const categories = Object.keys(Object.values(data)[0] as any);
    const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b'];
    
    return (
      <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
        <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
        
        {categories.map((category, idx) => {
          const points = years.map((year, i) => {
            const rawValue = (data[year] as any)[category];
            const value = parseChartValue(rawValue);
            const x = padding + (i * (width - 2*padding) / (years.length - 1));
            const maxValue = Math.max(...years.map(y => parseChartValue((data[y] as any)[category])), 1);
            const y = height - padding - ((value / maxValue) * (height - 2*padding));
            return `${x},${y}`;
          }).join(' ');
          
          return (
            <g key={category}>
              <polyline points={points} fill="none" stroke={colors[idx % colors.length]} strokeWidth="3" />
              {years.map((year, i) => {
                const rawValue = (data[year] as any)[category];
                const value = parseChartValue(rawValue);
                const x = padding + (i * (width - 2*padding) / (years.length - 1));
                const maxValue = Math.max(...years.map(y => parseChartValue((data[y] as any)[category])), 1);
                const y = height - padding - ((value / maxValue) * (height - 2*padding));
                return (
                  <text key={`${category}-${i}`} x={x} y={y - 10} textAnchor="middle" fontSize="10" fill={colors[idx % colors.length]}>
                    {formatChartValue(rawValue)}
                  </text>
                );
              })}
              <text x={width - padding + 10} y={30 + idx * 20} fontSize="11" fill={colors[idx % colors.length]}>
                {category}
              </text>
            </g>
          );
        })}
        
        {years.map((year, i) => {
          const x = padding + (i * (width - 2*padding) / (years.length - 1));
          return <text key={year} x={x} y={height-padding+20} textAnchor="middle" fontSize="11">{year}</text>;
        })}
        
        <line x1={padding} y1={height-padding} x2={width-padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
        <line x1={padding} y1={padding} x2={padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
      </svg>
    );
  }
  
  // Handle simple structure
  const entries = Object.entries(data).map(([key, value]) => [key, parseChartValue(value)]) as [string, number][];
  const maxValue = Math.max(...entries.map(([_, v]) => v), 1);
  const points = entries.map(([label, value], index) => {
    const x = padding + (index * (width - 2*padding) / (entries.length - 1));
    const y = height - padding - ((value / maxValue) * (height - 2*padding));
    return `${x},${y}`;
  }).join(' ');

  return (
    <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
      <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
      <polyline points={points} fill="none" stroke="#3b82f6" strokeWidth="3" />
      
      {entries.map(([label, value], index) => {
        const x = padding + (index * (width - 2*padding) / (entries.length - 1));
        const y = height - padding - ((value / maxValue) * (height - 2*padding));
        const originalValue = data[label];
        
        return (
          <g key={label}>
            <circle cx={x} cy={y} r="5" fill="#3b82f6" />
            <text x={x} y={height-padding+20} textAnchor="middle" fontSize="11">{label}</text>
            <text x={x} y={y-10} textAnchor="middle" fontSize="10" fill="#3b82f6">
              {formatChartValue(originalValue)}
            </text>
          </g>
        );
      })}
      
      <line x1={padding} y1={height-padding} x2={width-padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
      <line x1={padding} y1={padding} x2={padding} y2={height-padding} stroke="#666" strokeWidth="2"/>
    </svg>
  );
};

// ==========================================
// PIE CHART RENDERER
// ==========================================

const renderPieChart = (data: any, title: string) => {
  const width = 400;
  const height = 300;
  const centerX = width / 2;
  const centerY = height / 2 + 20;
  const radius = 100;
  const structure = detectDataStructure(data);
  
  if (structure === 'nested-categories') {
    // For pie charts, we'll sum up all values per category
    const categories = Object.keys(data);
    const entries = categories.map(cat => {
      const subValues = Object.values(data[cat] as any).map(v => parseChartValue(v));
      const total = subValues.reduce((sum, val) => sum + val, 0);
      return [cat, total] as [string, number];
    });
    
    const total = entries.reduce((sum, [_, value]) => sum + value, 0);
    let currentAngle = -90;
    const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'];

    return (
      <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
        <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
        
        {entries.map(([label, value], index) => {
          const percentage = total > 0 ? (value / total) * 100 : 0;
          const angle = total > 0 ? (value / total) * 360 : 0;
          const startAngle = currentAngle * Math.PI / 180;
          const endAngle = (currentAngle + angle) * Math.PI / 180;
          
          const x1 = centerX + radius * Math.cos(startAngle);
          const y1 = centerY + radius * Math.sin(startAngle);
          const x2 = centerX + radius * Math.cos(endAngle);
          const y2 = centerY + radius * Math.sin(endAngle);
          
          const largeArc = angle > 180 ? 1 : 0;
          const pathData = [`M ${centerX} ${centerY}`, `L ${x1} ${y1}`, `A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`, 'Z'].join(' ');
          
          currentAngle += angle;
          
          return (
            <g key={label}>
              <path d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="2"/>
              <text x={20} y={height - 60 + (index * 15)} fontSize="11" fill={colors[index % colors.length]}>
                {label}: {percentage.toFixed(1)}%
              </text>
            </g>
          );
        })}
      </svg>
    );
  }
  
  // Handle simple structure
  const entries = Object.entries(data).map(([key, value]) => [key, parseChartValue(value)]) as [string, number][];
  const total = entries.reduce((sum, [_, value]) => sum + value, 0);
  let currentAngle = -90;
  const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'];

  return (
    <svg width={width} height={height} style={{ border: '1px solid #e5e7eb', backgroundColor: 'white' }}>
      <text x={width/2} y={20} textAnchor="middle" fontSize="14" fontWeight="600">{title}</text>
      
      {entries.map(([label, value], index) => {
        const percentage = total > 0 ? (value / total) * 100 : 0;
        const angle = total > 0 ? (value / total) * 360 : 0;
        const startAngle = currentAngle * Math.PI / 180;
        const endAngle = (currentAngle + angle) * Math.PI / 180;
        
        const x1 = centerX + radius * Math.cos(startAngle);
        const y1 = centerY + radius * Math.sin(startAngle);
        const x2 = centerX + radius * Math.cos(endAngle);
        const y2 = centerY + radius * Math.sin(endAngle);
        
        const largeArc = angle > 180 ? 1 : 0;
        const pathData = [`M ${centerX} ${centerY}`, `L ${x1} ${y1}`, `A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`, 'Z'].join(' ');
        
        currentAngle += angle;
        const originalValue = data[label];
        
        return (
          <g key={label}>
            <path d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="2"/>
            <text x={20} y={height - 40 + (index * 15)} fontSize="11" fill={colors[index % colors.length]}>
              {label}: {percentage.toFixed(1)}% ({formatChartValue(originalValue)})
            </text>
          </g>
        );
      })}
    </svg>
  );
};

  // Chart editing handlers
  const handleChartTitleChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number, chartIndex: number) => {
    const newTitle = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].charts[chartIndex].title = newTitle;
      return updated;
    });
  };

  const handleChartDescriptionChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number, chartIndex: number) => {
    const newDescription = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].charts[chartIndex].description = newDescription;
      return updated;
    });
  };

  const deleteChart = (sectionIndex: number, chartIndex: number) => {
    if (!confirm('Delete this chart?')) return;
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].charts.splice(chartIndex, 1);
      return updated;
    });
  };

  // Handle inline text content changes
  const handleContentChange = (
    e: React.FormEvent<HTMLDivElement>,
    sectionIndex: number,
    paragraphIndex: number
  ) => {
    const newText = e.currentTarget.textContent || '';
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].paragraphs[paragraphIndex].text = newText;
      return updated;
    });
  };

  const handleTitleChange = (e: React.FormEvent<HTMLHeadingElement>) => {
    const newTitle = e.currentTarget.textContent || '';
    setReportData((prev: any) => ({
      ...prev,
      response: {
        ...prev.response,
        title: newTitle
      }
    }));
  };

  const handleSubtitleChange = (e: React.FormEvent<HTMLParagraphElement>) => {
    const newSubtitle = e.currentTarget.textContent || '';
    setReportData((prev: any) => ({
      ...prev,
      response: {
        ...prev.response,
        sub_title: newSubtitle
      }
    }));
  };

  const handleSectionHeadingChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number) => {
    const newHeading = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].heading = newHeading;
      return updated;
    });
  };

  const handleSectionSubHeadingChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number) => {
    const newSubHeading = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].sub_heading = newSubHeading;
      return updated;
    });
  };

  const handleListTitleChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number, listIndex: number) => {
    const newTitle = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists[listIndex].title = newTitle;
      return updated;
    });
  };

  const handleListDescriptionChange = (e: React.FormEvent<HTMLDivElement>, sectionIndex: number, listIndex: number) => {
    const newDescription = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists[listIndex].description = newDescription;
      return updated;
    });
  };

  const handleListItemChange = (e: React.FormEvent<HTMLLIElement>, sectionIndex: number, listIndex: number, itemIndex: number) => {
    const newItem = e.currentTarget.textContent || '';
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists[listIndex].items[itemIndex] = newItem;
      return updated;
    });
  };

  const handleFooterTextChange = (e: React.FormEvent<HTMLParagraphElement>) => {
    const newText = e.currentTarget.textContent || '';
    setFooterText(newText);
  };

  // Add new paragraph to section
  const addParagraph = (sectionIndex: number) => {
  setReportData((prev: any) => {
    const updated = { ...prev };
    if (!updated.response.sections[sectionIndex].paragraphs) {
      updated.response.sections[sectionIndex].paragraphs = [];
    }
    updated.response.sections[sectionIndex].paragraphs.push({
      text: "New paragraph - click to edit"
    });
    return updated;
  });
};

  // Delete paragraph
  const deleteParagraph = (sectionIndex: number, paragraphIndex: number) => {
    if (!confirm('Delete this paragraph?')) return;
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].paragraphs.splice(paragraphIndex, 1);
      return updated;
    });
  };

  // Add new section
 const addSection = () => {
  setReportData((prev: any) => {
    const updated = { ...prev };
    updated.response.sections.push({
      heading: "New Section - Click to Edit",
      sub_heading: "Subheading",
      paragraphs: [
        { text: "Start writing your content here..." }
      ],
      lists: [],
      charts: [],
      images: [],           // ADD THIS
      extracted_tables: []  // ADD THIS
    });
    return updated;
  });
};

  // Delete section
  const deleteSection = (sectionIndex: number) => {
    if (!confirm('Delete this entire section?')) return;
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections.splice(sectionIndex, 1);
      return updated;
    });
  };

  // Add new list to section
  const addList = (sectionIndex: number) => {
    setReportData((prev: any) => {
      const updated = { ...prev };
      if (!updated.response.sections[sectionIndex].lists) {
        updated.response.sections[sectionIndex].lists = [];
      }
      updated.response.sections[sectionIndex].lists.push({
        title: "New List Title",
        description: "List description",
        items: ["Item 1", "Item 2", "Item 3"]
      });
      return updated;
    });
  };

  // Add item to list
  const addListItem = (sectionIndex: number, listIndex: number) => {
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists[listIndex].items.push("New item");
      return updated;
    });
  };

  // Delete list item
  const deleteListItem = (sectionIndex: number, listIndex: number, itemIndex: number) => {
    if (!confirm('Delete this item?')) return;
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists[listIndex].items.splice(itemIndex, 1);
      return updated;
    });
  };

  // Delete entire list
  const deleteList = (sectionIndex: number, listIndex: number) => {
    if (!confirm('Delete this entire list?')) return;
    
    setReportData((prev: any) => {
      const updated = { ...prev };
      updated.response.sections[sectionIndex].lists.splice(listIndex, 1);
      return updated;
    });
  };

  // Insert image into section
  const insertImageInSection = (sectionIndex: number, e: React.ChangeEvent<HTMLInputElement>, fullWidth = false) => {
  handleImageUpload(e, (base64) => {
    setReportData((prev: any) => {
      const updated = { ...prev };
      if (!updated.response.sections[sectionIndex].paragraphs) {
        updated.response.sections[sectionIndex].paragraphs = [];
      }
      updated.response.sections[sectionIndex].paragraphs.push({
        text: "",
        image: base64,
        imageFullWidth: fullWidth
      });
      return updated;
    });
  });
};

  // Drag and Drop Handlers
  const handleDragStart = (e: React.DragEvent, type: 'paragraph' | 'section' | 'list' | 'chart', sectionIndex: number, itemIndex?: number, listIndex?: number, chartIndex?: number) => {
    setDraggedItem({ type, sectionIndex, itemIndex, listIndex, chartIndex });
    e.dataTransfer.effectAllowed = 'move';
    
    // Add visual feedback
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = '0.4';
    }
  };

  const handleDragEnd = (e: React.DragEvent) => {
    // Reset visual feedback
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = '1';
    }
    setDraggedItem(null);
    setDragOverItem(null);
  };

  const handleDragOver = (e: React.DragEvent, sectionIndex: number, itemIndex?: number) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'move';
    
    // Only update if different from current
    if (dragOverItem?.sectionIndex !== sectionIndex || dragOverItem?.itemIndex !== itemIndex) {
      setDragOverItem({ sectionIndex, itemIndex });
    }
  };

  const handleDrop = (e: React.DragEvent, targetSectionIndex: number, targetItemIndex?: number) => {
    e.preventDefault();
    
    if (!draggedItem) return;

    setReportData((prev: any) => {
      const updated = { ...prev };
      
      if (draggedItem.type === 'paragraph') {
        // Moving paragraphs
        const sourceParagraph = updated.response.sections[draggedItem.sectionIndex].paragraphs[draggedItem.itemIndex!];
        
        // Remove from source
        updated.response.sections[draggedItem.sectionIndex].paragraphs.splice(draggedItem.itemIndex!, 1);
        
        // Add to target
        const insertIndex = targetItemIndex !== undefined ? targetItemIndex : updated.response.sections[targetSectionIndex].paragraphs.length;
        updated.response.sections[targetSectionIndex].paragraphs.splice(insertIndex, 0, sourceParagraph);
        
      } else if (draggedItem.type === 'chart') {
        // Moving charts
        const sourceChart = updated.response.sections[draggedItem.sectionIndex].charts[draggedItem.chartIndex!];
        
        // Remove from source
        updated.response.sections[draggedItem.sectionIndex].charts.splice(draggedItem.chartIndex!, 1);
        
        // Add to target
        if (!updated.response.sections[targetSectionIndex].charts) {
          updated.response.sections[targetSectionIndex].charts = [];
        }
        const insertIndex = targetItemIndex !== undefined ? targetItemIndex : updated.response.sections[targetSectionIndex].charts.length;
        updated.response.sections[targetSectionIndex].charts.splice(insertIndex, 0, sourceChart);
        
      } else if (draggedItem.type === 'section') {
        // Moving entire sections
        const sourceSection = updated.response.sections[draggedItem.sectionIndex];
        
        // Remove from source
        updated.response.sections.splice(draggedItem.sectionIndex, 1);
        
        // Add to target
        const insertIndex = targetSectionIndex > draggedItem.sectionIndex ? targetSectionIndex - 1 : targetSectionIndex;
        updated.response.sections.splice(insertIndex, 0, sourceSection);
        
      } else if (draggedItem.type === 'list') {
        // Moving lists within same section
        if (draggedItem.sectionIndex === targetSectionIndex && draggedItem.listIndex !== undefined) {
          const sourceList = updated.response.sections[draggedItem.sectionIndex].lists[draggedItem.listIndex];
          
          // Remove from source
          updated.response.sections[draggedItem.sectionIndex].lists.splice(draggedItem.listIndex, 1);
          
          // Add to target (assuming targetItemIndex represents list position)
          const insertIndex = targetItemIndex !== undefined ? targetItemIndex : updated.response.sections[targetSectionIndex].lists.length;
          updated.response.sections[targetSectionIndex].lists.splice(insertIndex, 0, sourceList);
        }
      }
      
      return updated;
    });

    setDraggedItem(null);
    setDragOverItem(null);
  };

  // Show loading state while converting images
  if (!base64Images.research || !base64Images.background || !base64Images.globe) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Generating Report...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {contextMenu?.show && (
        <div
          style={{
            position: 'fixed',
            top: contextMenu.y,
            left: contextMenu.x,
            backgroundColor: 'white',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 9999,
            minWidth: '180px',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={handleEnhanceImage}
            style={{
              width: '100%',
              padding: '12px 16px',
              textAlign: 'left',
              border: 'none',
              background: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#374151',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '6px',
              fontWeight: 500
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f3f4f6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'white';
            }}
          >
            <span style={{ fontSize: '18px' }}>✨</span>
            <span>Enhance Image Quality</span>
          </button>
        </div>
      )}

      {/* Click outside to close context menu */}
      {contextMenu?.show && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9998
          }}
          onClick={() => setContextMenu(null)}
        />
      )}

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
            @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          
          .edit-button, .insert-button, .delete-button {
            transition: all 0.2s ease;
          }
          
          .edit-button:hover, .insert-button:hover, .delete-button:hover {
            transform: scale(1.05);
          }
        `}
      </style>

      <div className="sticky top-0 bg-white h-12 flex justify-between items-center border-b border-gray-500 px-4 z-50">
        <h2 className="text-gray-900 font-semibold text-lg">Whitepaper generation agent report</h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          {/* Edit Mode Toggle */}
          {!isSuccess && (
            <button
              onClick={() => setIsEditMode(!isEditMode)}
              className={`rounded-xl text-sm inline-flex justify-center items-center px-[12px] py-[10px] font-medium ${
                isEditMode 
                  ? 'bg-orange-500 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {isEditMode ? '✓ Save Edits' : '✎ Enable Edit Mode'}
            </button>
          )}

          {isSuccess ? (
            <div className="flex flex-row gap-2">
              <a
                href={`${API_PROD_URL}/whitepaper-agent-v1/download_html?user_id=${reportData?.userId}&thread_id=${reportData?.threadId}`}
                target="_blank"
                rel="noopener noreferrer"
                className='rounded-xl text-sm text-white inline-flex justify-center items-center px-[12px] py-[10px] bg-primary-900 font-medium'
              >
                Download HTML
              </a>
              <a
                href={`${API_PROD_URL}/whitepaper-agent-v1/download_pdf?user_id=${reportData?.userId}&thread_id=${reportData?.threadId}`}
                target="_blank"
                rel="noopener noreferrer"
                className='rounded-xl text-sm text-white inline-flex justify-center items-center px-[12px] py-[10px] bg-primary-900 font-medium'
              >
                Download PDF
              </a>
            </div>
          ) : (
            <button
              onClick={handleConfirmLayout}
              disabled={isSubmitting}
              style={{
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                opacity: isSubmitting ? 0.5 : 1
              }}
              className='rounded-xl text-sm text-white inline-flex justify-center items-center px-[12px] py-[10px] bg-primary-900 font-medium'
            >
              {isSubmitting ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg style={{ animation: 'spin 1s linear infinite', height: '8px', width: '8px', marginRight: '8px' }} viewBox="0 0 24 24">
                    <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Confirming Whitepaper
                </span>
              ) : (
                'Confirm Whitepaper'
              )}
            </button>
          )}
        </div>
      </div>

      {/* Edit Mode Info Banner */}
      {isEditMode && (
        <div className="bg-orange-50 border-l-4 border-orange-500 p-3 mb-4 mx-4 mt-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-orange-500" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-orange-700">
                <strong>Edit Mode Active:</strong> Click any text to edit • Hover over images to replace • Use + buttons to add content • Use 🗑️ to delete • <strong>Drag paragraphs/images/charts anywhere (even across sections!)</strong>
              </p>
            </div>
          </div>
        </div>
      )}

      <div ref={emailLayoutRef}>
        {/* ================= COVER PAGE ================= */}
        <table cellPadding={0} cellSpacing={0} style={pageStyle}>
          <tbody>
            <tr>
              <td style={{ border: "none", verticalAlign: "top", padding: "40px 40px 0" }}>
                <table width="100%" style={{ border: "none" }}>
                  <tbody style={{ border: "none" }}>
                    <tr style={{ border: "none" }}>
                      <td>
                        <img
                          src="https://www.broadridge.com/_Static-Assets/images/brodridgeLogo.svg"
                          width="180"
                          alt="Broadridge"
                          style={{ border: "none" }}
                        />
                      </td>
                      <td 
                        contentEditable={isEditMode}
                        suppressContentEditableWarning
                        onBlur={(e) => setEnterpriseLabel(e.currentTarget.textContent || '')}
                        align="right" 
                        style={{ 
                          color: "#1f4fd8", 
                          fontSize: "12px", 
                          fontWeight: 600,
                          outline: isEditMode ? '2px dashed #f97316' : 'none',
                          padding: isEditMode ? '4px' : '0',
                          cursor: isEditMode ? 'text' : 'default'
                        }}
                      >
                        {enterpriseLabel}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td style={{ border: "none", verticalAlign: "top", padding: "0 40px" }}>
                <h1 
                  contentEditable={isEditMode}
                  suppressContentEditableWarning
                  onBlur={handleTitleChange}
                  style={{ 
                    fontSize: "36px", 
                    color: "#1f4fd8", 
                    marginTop: "40px",
                    outline: isEditMode ? '2px dashed #f97316' : 'none',
                    padding: isEditMode ? '4px' : '0',
                    cursor: isEditMode ? 'text' : 'default'
                  }}
                >
                  {reportData?.response?.title}
                </h1>
                <p 
                  contentEditable={isEditMode}
                  suppressContentEditableWarning
                  onBlur={handleSubtitleChange}
                  style={{ 
                    fontSize: "16px", 
                    color: "#5f6f85", 
                    maxWidth: "520px",
                    outline: isEditMode ? '2px dashed #f97316' : 'none',
                    padding: isEditMode ? '4px' : '0',
                    cursor: isEditMode ? 'text' : 'default'
                  }}
                >
                  {reportData?.response?.sub_title}
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ border: "none", verticalAlign: "top", padding: "0 40px", position: 'relative' }}>
                <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                  <img
                    src={coverImage}
                    alt=""
                    style={{ width: "100%", height: "420px", objectFit: "cover", marginTop: "30px" }}
                  />
                  {isEditMode && (
                    <div className="edit-overlay" style={{
                      position: 'absolute',
                      top: '40px',
                      right: '10px',
                      background: 'rgba(0,0,0,0.7)',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}>
                      <label style={{ color: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>
                        📷 Replace Cover Image
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={(e) => handleImageUpload(e, setCoverImage)}
                        />
                      </label>
                    </div>
                  )}
                </div>
              </td>
            </tr>

            <tr>
              <td style={{ border: "none", verticalAlign: "bottom", padding: "0 40px 40px" }}>
                <table width="100%" style={{ marginTop: "0", border: "none" }}>
                  <tbody>
                    <tr>
                      <td style={{ fontSize: "12px", color: "#5f6f85", border: "none" }}>
                        <div
                          contentEditable={isEditMode}
                          suppressContentEditableWarning
                          onBlur={(e) => setCollaborationText(e.currentTarget.textContent || '')}
                          style={{
                            outline: isEditMode ? '2px dashed #f97316' : 'none',
                            padding: isEditMode ? '4px' : '0',
                            cursor: isEditMode ? 'text' : 'default',
                            display: 'inline-block'
                          }}
                        >
                          {collaborationText}
                        </div>
                        <br />
                        <img 
                          src={base64Images.research} 
                          height="30" 
                          alt="Research Logo" 
                          style={{ height: "50px" }} 
                        />
                      </td>
                      <td 
                        contentEditable={isEditMode}
                        suppressContentEditableWarning
                        onBlur={(e) => setReadyForNextLabel(e.currentTarget.textContent || '')}
                        align="right" 
                        style={{ 
                          color: "#1f4fd8", 
                          fontWeight: 600, 
                          border: "none",
                          outline: isEditMode ? '2px dashed #f97316' : 'none',
                          padding: isEditMode ? '4px' : '0',
                          cursor: isEditMode ? 'text' : 'default'
                        }}
                      >
                        {readyForNextLabel}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ================= TOC PAGE ================= */}
        <table
          cellPadding={0}
          cellSpacing={0}
          style={{
            width: 794,
            backgroundImage: `url("${base64Images.background}")`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            color: "#ffffff",
            maxHeight: "100dvh",
            minHeight: "1123px",
            boxShadow: "0 0 10px rgba(0,0,0,.15)",
            marginBottom: "35px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  padding: "110px 90px",
                  border: "none",
                  verticalAlign: "top",
                  backgroundImage: `url("${base64Images.globe}")`,
                  backgroundSize: "50% auto",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "bottom 100px left",
                }}
              >
                <div 
                  contentEditable={isEditMode}
                  suppressContentEditableWarning
                  onBlur={(e) => setTocTitle(e.currentTarget.textContent || '')}
                  style={{ 
                    fontSize: "11px", 
                    letterSpacing: "1.6px", 
                    marginBottom: "20px",
                    outline: isEditMode ? '2px dashed #fbbf24' : 'none',
                    padding: isEditMode ? '4px' : '0',
                    cursor: isEditMode ? 'text' : 'default',
                    display: 'inline-block'
                  }}
                >
                  {tocTitle}
                </div>

                <table width="430" style={{ border: "none",color: "#ffffff" }}>
                  <tbody style={{ border: "none",color: "#ffffff" }}>
                    {reportData?.response?.sections.map((s: any, i: any) => (
                      <tr key={i}> 
                        <td 
                          contentEditable={isEditMode}
                          suppressContentEditableWarning
                          onBlur={(e) => {
                            const newHeading = e.currentTarget.textContent || '';
                            setReportData((prev: any) => {
                              const updated = { ...prev };
                              updated.response.sections[i].heading = newHeading;
                              return updated;
                            });
                          }}
                          style={{ 
                            fontSize: "13px", 
                            borderBottom: "1px dotted rgba(255,255,255,0.3)", 
                            padding: "10px 0", 
                            color: "#ffffff",
                            outline: isEditMode ? '2px dashed #fbbf24' : 'none',
                            cursor: isEditMode ? 'text' : 'default'
                          }}
                        >
                          {s.heading}
                        </td>
                        <td align="right" style={{ fontSize: "13px" , color: "#ffffff" }}>
                          {i + 3}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ================= SECTION PAGES ================= */}
        {reportData?.response?.sections.map((section: any, sectionIndex: any) => (
          <table
            key={sectionIndex}
            cellPadding={0}
            cellSpacing={0}
            style={{
              width: 794,
              minHeight: 1123,
              marginBottom: "35px",
              border: "none",
              borderCollapse: "collapse",
              backgroundColor: "#ffffff",
              fontFamily: "Arial, Helvetica, sans-serif",
              breakAfter: "page",
              pageBreakAfter: "always",
              boxShadow: "0 0 10px rgba(0,0,0,.15)",
              position: 'relative'
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    border: "none",
                    padding: "40px",
                  }}
                >
                  {/* Section Action Buttons */}
                  {isEditMode && (
                    <div className="action-buttons" style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      display: 'flex',
                      gap: '8px',
                      zIndex: 10,
                      alignItems: 'center'
                    }}>
                      <button
                        className="delete-button"
                        onClick={() => deleteSection(sectionIndex)}
                        style={{
                          background: '#dc2626',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          padding: '6px 12px',
                          fontSize: '12px',
                          cursor: 'pointer',
                          fontWeight: 600
                        }}
                      >
                        🗑️ Delete Section
                      </button>
                    </div>
                  )}

                  <div
                    contentEditable={isEditMode}
                    suppressContentEditableWarning
                    onBlur={(e) => handleSectionHeadingChange(e, sectionIndex)}
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "#1e40af",
                      marginBottom: "6px",
                      outline: isEditMode ? '2px dashed #f97316' : 'none',
                      padding: isEditMode ? '4px' : '0',
                      cursor: isEditMode ? 'text' : 'default'
                    }}
                  >
                    {section.heading}
                  </div>

                  {section.sub_heading && (
                    <div
                      contentEditable={isEditMode}
                      suppressContentEditableWarning
                      onBlur={(e) => handleSectionSubHeadingChange(e, sectionIndex)}
                      style={{
                        fontSize: "14px",
                        color: "#3b82f6",
                        marginBottom: "24px",
                        outline: isEditMode ? '2px dashed #f97316' : 'none',
                        padding: isEditMode ? '4px' : '0',
                        cursor: isEditMode ? 'text' : 'default'
                      }}
                    >
                      {section.sub_heading}
                    </div>
                  )}

                  

                  <table
                    width="100%"
                    cellPadding={0}
                    cellSpacing={0}
                    style={{
                      border: "none",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      {/* Render content with proper full-width image handling */}
                      {(() => {
                        const content = section.paragraphs || [];
                        const elements: JSX.Element[] = [];
                        let columnContent: any[] = [];
                        
                        content.forEach((paragraph: any, paragraphIndex: number) => {
                          // If it's a full-width image, flush column content and render image separately
                          if (paragraph.image && paragraph.imageFullWidth) {
                            // First, render accumulated column content
                            if (columnContent.length > 0) {
                              elements.push(
                                <tr key={`col-${paragraphIndex}`}>
                                  <td
                                    style={{
                                      verticalAlign: "top",
                                      paddingRight: "30px",
                                      border: "none",
                                    }}
                                  >
                                    <div style={{
                                      width: '100%',
                                      display:'grid',                                       
                                      gridTemplateColumns:'1fr 1fr', 
                                      columnGap: "40px",                                      
                                    } as any}>
                                      {columnContent}
                                    </div>
                                  </td>
                                </tr>
                              );
                              columnContent = [];
                            }
                            
                            // Then render full-width image
                            elements.push(
                              <tr key={`img-${paragraphIndex}`}>
                                <td style={{ verticalAlign: "top", border: "none", paddingRight: "30px" }}>
                                  <div 
                                    draggable={isEditMode}
                                    onDragStart={(e) => handleDragStart(e, 'paragraph', sectionIndex, paragraphIndex)}
                                    onDragEnd={handleDragEnd}
                                    onDragOver={(e) => handleDragOver(e, sectionIndex, paragraphIndex)}
                                    onDrop={(e) => handleDrop(e, sectionIndex, paragraphIndex)}
                                    style={{ 
                                      position: 'relative', 
                                      marginBottom: '18px',
                                      cursor: isEditMode ? 'move' : 'default',
                                      border: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '3px dashed #3b82f6' : 'none',
                                      padding: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '8px' : '0'
                                    }}
                                  >
                                    <img 
                                      src={paragraph.image} 
                                      alt="" 
                                      style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        maxHeight: '400px',
                                        objectFit: 'contain',
                                        display: 'block'
                                      }} 
                                    />
                                    {isEditMode && (
                                      <div className="action-buttons" style={{
                                        position: 'absolute',
                                        top: '5px',
                                        right: '5px',
                                        display: 'flex',
                                        gap: '5px',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end'
                                      }}>
                                        <span style={{
                                          cursor: 'move',
                                          fontSize: '12px',
                                          color: '#6366f1',
                                          padding: '3px 6px',
                                          background: '#e0e7ff',
                                          borderRadius: '4px',
                                          fontWeight: 600
                                        }}>
                                          ⋮⋮
                                        </span>
                                        <button
                                          className="delete-button"
                                          onClick={() => {
                                            setReportData((prev: any) => {
                                              const updated = { ...prev };
                                              updated.response.sections[sectionIndex].paragraphs[paragraphIndex].imageFullWidth = !paragraph.imageFullWidth;
                                              return updated;
                                            });
                                          }}
                                          style={{
                                            background: '#3b82f6',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            fontSize: '10px',
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap'
                                          }}
                                        >
                                          {paragraph.imageFullWidth ? '↔️ Half' : '↔️ Full'}
                                        </button>
                                        <button
                                          className="delete-button"
                                          onClick={() => deleteParagraph(sectionIndex, paragraphIndex)}
                                          style={{
                                            background: '#dc2626',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            fontSize: '11px',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          🗑️
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          } else {
                            // Add to column content (regular paragraphs and half-width images)
                            columnContent.push(
                              paragraph.image ? (
                                // Half-width image
                                <div 
                                  key={paragraphIndex}
                                  draggable={isEditMode}
                                  onDragStart={(e) => handleDragStart(e, 'paragraph', sectionIndex, paragraphIndex)}
                                  onDragEnd={handleDragEnd}
                                  onDragOver={(e) => handleDragOver(e, sectionIndex, paragraphIndex)}
                                  onDrop={(e) => handleDrop(e, sectionIndex, paragraphIndex)}
                                  style={{ 
                                    position: 'relative', 
                                    marginBottom: '18px',
                                    breakInside: 'avoid',
                                    cursor: isEditMode ? 'move' : 'default',
                                    border: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '2px dashed #3b82f6' : 'none',
                                    padding: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '4px' : '0',
                                  }}
                                >
                                  <img 
                                    src={paragraph.image} 
                                    alt="" 
                                    style={{ 
                                      width: '100%', 
                                      height: 'auto', 
                                      maxHeight: '300px',
                                      objectFit: 'contain'
                                    }} 
                                  />
                                  {isEditMode && (
                                    <div className="action-buttons" style={{
                                      position: 'absolute',
                                      top: '5px',
                                      right: '5px',
                                      display: 'flex',
                                      gap: '5px',
                                      flexDirection: 'column',
                                      alignItems: 'flex-end'
                                    }}>
                                      <span style={{
                                        cursor: 'move',
                                        fontSize: '12px',
                                        color: '#6366f1',
                                        padding: '3px 6px',
                                        background: '#e0e7ff',
                                        borderRadius: '4px',
                                        fontWeight: 600
                                      }}>
                                        ⋮⋮
                                      </span>
                                      <button
                                        className="delete-button"
                                        onClick={() => {
                                          setReportData((prev: any) => {
                                            const updated = { ...prev };
                                            updated.response.sections[sectionIndex].paragraphs[paragraphIndex].imageFullWidth = !paragraph.imageFullWidth;
                                            return updated;
                                          });
                                        }}
                                        style={{
                                          background: '#3b82f6',
                                          color: 'white',
                                          border: 'none',
                                          borderRadius: '4px',
                                          padding: '4px 8px',
                                          fontSize: '10px',
                                          cursor: 'pointer',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {paragraph.imageFullWidth ? '↔️ Half' : '↔️ Full'}
                                      </button>
                                      <button
                                        className="delete-button"
                                        onClick={() => deleteParagraph(sectionIndex, paragraphIndex)}
                                        style={{
                                          background: '#dc2626',
                                          color: 'white',
                                          border: 'none',
                                          borderRadius: '4px',
                                          padding: '4px 8px',
                                          fontSize: '11px',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        🗑️
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                // Text paragraph - NO OUTER DIV WRAPPER
                                <p
                                  key={paragraphIndex}
                                  draggable={isEditMode}
                                  onDragStart={(e) => handleDragStart(e, 'paragraph', sectionIndex, paragraphIndex)}
                                  onDragEnd={handleDragEnd}
                                  onDragOver={(e) => handleDragOver(e, sectionIndex, paragraphIndex)}
                                  onDrop={(e) => handleDrop(e, sectionIndex, paragraphIndex)}
                                  contentEditable={isEditMode}
                                  suppressContentEditableWarning
                                  onBlur={(e) => handleContentChange(e, sectionIndex, paragraphIndex)}
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "1.5",
                                    color: "#1f2937",
                                    marginBottom: "18px",
                                    border: "none",
                                    textAlign: "justify",
                                    outline: isEditMode ? '2px dashed #f97316' : 'none',
                                    padding: isEditMode ? '4px' : '0',
                                    cursor: isEditMode ? 'text' : 'default',
                                    position: 'relative',
                                    borderLeft: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '3px solid #3b82f6' : 'none',
                                    paddingLeft: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === paragraphIndex ? '8px' : '0',
                                  }}
                                >
                                  {paragraph.text}
                                  {isEditMode && (
                                    <span className="action-buttons" style={{
                                      position: 'absolute',
                                      top: '0',
                                      right: '0',
                                      display: 'inline-flex',
                                      gap: '5px',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{
                                        cursor: 'move',
                                        fontSize: '14px',
                                        color: '#6366f1',
                                        padding: '2px 4px',
                                        background: '#e0e7ff',
                                        borderRadius: '3px'
                                      }}>
                                        ⋮⋮
                                      </span>
                                      <button
                                        className="delete-button"
                                        onClick={() => deleteParagraph(sectionIndex, paragraphIndex)}
                                        style={{
                                          background: '#dc2626',
                                          color: 'white',
                                          border: 'none',
                                          borderRadius: '4px',
                                          padding: '4px 8px',
                                          fontSize: '11px',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        🗑️
                                      </button>
                                    </span>
                                  )}
                                </p>
                              )
                            );
                          }
                        });
                        
                        // Flush any remaining column content
                        if (columnContent.length > 0) {
                          elements.push(
                            <tr key="col-final">
                              <td
                                style={{
                                  verticalAlign: "top",
                                  paddingRight: "30px",
                                  border: "none",
                                }}
                              >
                                <div style={{
                                  width: '100%',
                                  display:'grid',
                                  gridTemplateColumns:'1fr 1fr', 
                                  columnGap: "40px",
                                } as any}>
                                  {columnContent}

                                  {/* Lists Section */}
                                {section.lists && section.lists.length > 0 && (
                                  
                                      <div style={{
                                        width: '100%',
                                      } as any}>
                                        {section.lists.map((list: any, listIndex: any) => (
                                        <div key={listIndex} style={{ position: 'relative', breakInside: 'avoid', marginBottom: '20px' }}>
                                          {isEditMode && (
                                            <div className="action-buttons" style={{
                                              position: 'absolute',
                                              top: '0',
                                              right: '0',
                                              display: 'flex',
                                              gap: '5px',
                                              zIndex: 5
                                            }}>
                                              <button
                                                className="delete-button"
                                                onClick={() => deleteList(sectionIndex, listIndex)}
                                                style={{
                                                  background: '#dc2626',
                                                  color: 'white',
                                                  border: 'none',
                                                  borderRadius: '4px',
                                                  padding: '4px 8px',
                                                  fontSize: '11px',
                                                  cursor: 'pointer'
                                                }}
                                              >
                                                🗑️ Delete List
                                              </button>
                                            </div>
                                          )}

                                          <div
                                            contentEditable={isEditMode}
                                            suppressContentEditableWarning
                                            onBlur={(e) => handleListTitleChange(e, sectionIndex, listIndex)}
                                            style={{
                                              fontSize: "16px",
                                              fontWeight: 600,
                                              color: "#1e40af",
                                              marginBottom: "6px",
                                              outline: isEditMode ? '2px dashed #f97316' : 'none',
                                              padding: isEditMode ? '4px' : '0',
                                              cursor: isEditMode ? 'text' : 'default'
                                            }}
                                          >
                                            {list.title}
                                          </div>

                                          {list.description && (
                                            <div
                                              contentEditable={isEditMode}
                                              suppressContentEditableWarning
                                              onBlur={(e) => handleListDescriptionChange(e, sectionIndex, listIndex)}
                                              style={{
                                                fontSize: "13px",
                                                color: "#3b82f6",
                                                marginBottom: "12px",
                                                outline: isEditMode ? '2px dashed #f97316' : 'none',
                                                padding: isEditMode ? '4px' : '0',
                                                cursor: isEditMode ? 'text' : 'default'
                                              }}
                                            >
                                              {list.description}
                                            </div>
                                          )}

                                          <ul
                                            style={{
                                              paddingLeft: "18px",
                                              margin: 0,
                                              listStyleType: "disc",
                                              color: "#1f2937",
                                              fontSize: "13px",
                                              lineHeight: "1.5",
                                            }}
                                          >
                                            {list.items.map((item: any, itemIndex: any) => (
                                              <li
                                                key={itemIndex}
                                                contentEditable={isEditMode}
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleListItemChange(e, sectionIndex, listIndex, itemIndex)}
                                                style={{
                                                  marginBottom: "6px",
                                                  outline: isEditMode ? '2px dashed #f97316' : 'none',
                                                  padding: isEditMode ? '4px' : '0',
                                                  cursor: isEditMode ? 'text' : 'default',
                                                  position: 'relative'
                                                }}
                                              >
                                                {item}
                                                {isEditMode && (
                                                  <button
                                                    className="delete-button"
                                                    onClick={() => deleteListItem(sectionIndex, listIndex, itemIndex)}
                                                    style={{
                                                      background: '#dc2626',
                                                      color: 'white',
                                                      border: 'none',
                                                      borderRadius: '3px',
                                                      padding: '2px 6px',
                                                      fontSize: '10px',
                                                      cursor: 'pointer',
                                                      marginLeft: '8px'
                                                    }}
                                                  >
                                                    🗑️
                                                  </button>
                                                )}
                                              </li>
                                            ))}
                                          </ul>

                                          {isEditMode && (
                                            <button
                                              className="insert-button"
                                              onClick={() => addListItem(sectionIndex, listIndex)}
                                              style={{
                                                background: '#10b981',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                fontSize: '11px',
                                                cursor: 'pointer',
                                                marginTop: '8px',
                                                fontWeight: 600
                                              }}
                                            >
                                              + Add Item
                                            </button>
                                          )}
                                        </div>
                                      ))}
                                      </div>
                                  
                                )}
                      
                                </div>

                                
                              </td>
                            </tr>
                          );
                        }
                        
                        return elements;
                      })()}

                      {/* Add Paragraph/Image Buttons */}
                      {isEditMode && (
                        <tr>
                          <td style={{ verticalAlign: "top", border: "none", paddingRight: "30px" }}>
                            <div style={{ 
                              display: 'flex', 
                              gap: '8px', 
                              marginTop: '20px',
                              marginBottom: '20px',
                              flexWrap: 'wrap'
                            }}>
                              <button
                                className="insert-button"
                                onClick={() => addParagraph(sectionIndex)}
                                style={{
                                  background: '#10b981',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px 12px',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                + Add Paragraph
                              </button>
                              <label
                                className="insert-button"
                                style={{
                                  background: '#3b82f6',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px 12px',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                + Image (Half)
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{ display: 'none' }}
                                  onChange={(e) => insertImageInSection(sectionIndex, e, false)}
                                />
                              </label>
                              <label
                                className="insert-button"
                                style={{
                                  background: '#0ea5e9',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px 12px',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                + Image (Full Width)
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{ display: 'none' }}
                                  onChange={(e) => insertImageInSection(sectionIndex, e, true)}
                                />
                              </label>
                              <button
                                className="insert-button"
                                onClick={() => addList(sectionIndex)}
                                style={{
                                  background: '#8b5cf6',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px 12px',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                + Add List
                              </button>
                            </div>

                            {/* Drop Zone for dragging items into this section */}
                            {isEditMode && draggedItem && (
                              <div
                                onDragOver={(e) => handleDragOver(e, sectionIndex, section.paragraphs.length)}
                                onDrop={(e) => handleDrop(e, sectionIndex, section.paragraphs.length)}
                                style={{
                                  minHeight: '40px',
                                  marginTop: '10px',
                                  marginBottom: '10px',
                                  border: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === section.paragraphs.length 
                                    ? '2px dashed #3b82f6' 
                                    : '2px dashed transparent',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#6b7280',
                                  fontSize: '12px',
                                  transition: 'all 0.2s ease',
                                  background: dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === section.paragraphs.length
                                    ? 'rgba(59, 130, 246, 0.05)'
                                    : 'transparent'
                                }}
                              >
                                {dragOverItem?.sectionIndex === sectionIndex && dragOverItem?.itemIndex === section.paragraphs.length && '↓ Drop here ↓'}
                              </div>
                            )}
                          </td>
                        </tr>
                      )}

                      
                    </tbody>
                  </table>

                  {/* Render Images from section.images array */}
                  {section.images && section.images.length > 0 && (
                    <div style={{ marginBottom: '24px' }}>
                      {section.images.map((image: any, imageIndex: number) => (
                        <div 
                          key={`section-image-${imageIndex}`}
                          style={{ 
                            position: 'relative', 
                            marginBottom: '18px',
                            breakInside: 'avoid'
                          }}
                        >
                          
                         <div style={{ position: 'relative' }}>
          <img 
            src={image.file_url} 
            alt={image.title || ''} 
            onContextMenu={(e) => handleImageRightClick(e, sectionIndex, imageIndex, image.file_url)}
            style={{ 
              width: '100%', 
              height: 'auto', 
              maxHeight: '400px',
              objectFit: 'contain',
              display: 'block',
              border: '1px solid #e5e7eb',
              cursor: 'context-menu' // Show user they can right-click
            }} 
          />
          
          {/* Loading overlay while enhancing */}
          {enhancingImageKey === `${sectionIndex}-${imageIndex}` && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(255, 255, 255, 0.95)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #e5e7eb',
                  borderTop: '4px solid #3b82f6',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  margin: '0 auto'
                }} />
                <p style={{ 
                  marginTop: '12px', 
                  color: '#3b82f6', 
                  fontWeight: 600,
                  fontSize: '14px'
                }}>
                  Enhancing image...
                </p>
              </div>
            </div>
          )}
        </div>


                            {image.title && (
                            <div
                              contentEditable={isEditMode}
                              suppressContentEditableWarning
                              onBlur={(e) => {
                                const newTitle = e.currentTarget.textContent || '';
                                setReportData((prev: any) => {
                                  const updated = { ...prev };
                                  updated.response.sections[sectionIndex].images[imageIndex].title = newTitle;
                                  return updated;
                                });
                              }}
                              style={{
                                fontSize: "10px",
                                textAlign: "center",
                                fontWeight: 600,
                                color: "#616161",
                                marginTop: "8px",
                                outline: isEditMode ? '2px dashed #f97316' : 'none',
                                padding: isEditMode ? '4px' : '0',
                                cursor: isEditMode ? 'text' : 'default'
                              }}
                            >
                              {image.title}
                            </div>
                          )}
                          {isEditMode && (
                            <button
                              className="delete-button"
                              onClick={() => {
                                if (!confirm('Delete this image?')) return;
                                setReportData((prev: any) => {
                                  const updated = { ...prev };
                                  updated.response.sections[sectionIndex].images.splice(imageIndex, 1);
                                  return updated;
                                });
                              }}
                              style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                background: '#dc2626',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                fontSize: '11px',
                                cursor: 'pointer'
                              }}
                            >
                              🗑️
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Render Charts (before paragraphs) */}
                  {section.charts && section.charts.length > 0 && (
                    <div style={{ marginBottom: '24px' }}>
                      {section.charts.map((chart: any, chartIndex: number) => (
                        renderChart(chart, sectionIndex, chartIndex)
                      ))}
                    </div>
                  )}

               

                      {/* Render Tables from section.extracted_tables array */}
                    {section.extracted_tables && section.extracted_tables.length > 0 && (
                      <div style={{ marginBottom: '24px' }}>
                        {section.extracted_tables.map((tableData: any, tableIndex: number) => (
                          <div 
                            key={`section-table-${tableIndex}`}
                            style={{ 
                              position: 'relative', 
                              marginBottom: '24px',
                              breakInside: 'avoid',
                              overflowX: 'auto'
                            }}
                          >
                            {tableData.title && (
                              <div
                                contentEditable={isEditMode}
                                suppressContentEditableWarning
                                onBlur={(e) => {
                                  const newTitle = e.currentTarget.textContent || '';
                                  setReportData((prev: any) => {
                                    const updated = { ...prev };
                                    updated.response.sections[sectionIndex].extracted_tables[tableIndex].title = newTitle;
                                    return updated;
                                  });
                                }}
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "#1e40af",
                                  marginBottom: "12px",
                                  outline: isEditMode ? '2px dashed #f97316' : 'none',
                                  padding: isEditMode ? '4px' : '0',
                                  cursor: isEditMode ? 'text' : 'default'
                                }}
                              >
                                {tableData.title}
                              </div>
                            )}
                            <table style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              border: '1px solid #e5e7eb',
                              fontSize: '13px'
                            }}>
                              <tbody>
                                {tableData.data.map((row: any[], rowIndex: number) => (
                                  <tr key={rowIndex} style={{
                                    backgroundColor: rowIndex === 0 ? '#f3f4f6' : rowIndex % 2 === 0 ? '#ffffff' : '#f9fafb'
                                  }}>
                                    {row.map((cell: any, cellIndex: number) => {
                                      const CellTag = rowIndex === 0 ? 'th' : 'td';
                                      return (
                                        <CellTag
                                          key={cellIndex}
                                          contentEditable={isEditMode}
                                          suppressContentEditableWarning
                                          onBlur={(e) => {
                                            const newValue = e.currentTarget.textContent || '';
                                            setReportData((prev: any) => {
                                              const updated = { ...prev };
                                              updated.response.sections[sectionIndex].extracted_tables[tableIndex].data[rowIndex][cellIndex] = newValue;
                                              return updated;
                                            });
                                          }}
                                          style={{
                                            border: '1px solid #e5e7eb',
                                            padding: '8px 12px',
                                            textAlign: 'left',
                                            fontWeight: rowIndex === 0 ? 600 : 400,
                                            outline: isEditMode ? '1px dashed #f97316' : 'none',
                                            cursor: isEditMode ? 'text' : 'default'
                                          }}
                                        >
                                          {cell}
                                        </CellTag>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {isEditMode && (
                              <button
                                className="delete-button"
                                onClick={() => {
                                  if (!confirm('Delete this table?')) return;
                                  setReportData((prev: any) => {
                                    const updated = { ...prev };
                                    updated.response.sections[sectionIndex].extracted_tables.splice(tableIndex, 1);
                                    return updated;
                                  });
                                }}
                                style={{
                                  marginTop: '8px',
                                  background: '#dc2626',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  padding: '6px 12px',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                🗑️ Delete Table
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                </td>
              </tr>
            </tbody>
          </table>
        ))}

        {/* Add New Section Button */}
        {isEditMode && (
          <div className="add-section-container" style={{ 
            textAlign: 'center', 
            margin: '20px 0',
            padding: '20px',
            backgroundColor: '#f3f4f6',
            borderRadius: '8px'
          }}>
            <button
              className="add-section-btn"
              onClick={addSection}
              style={{
                background: '#6366f1',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                cursor: 'pointer',
                fontWeight: 700
              }}
            >
              + Add New Section
            </button>
          </div>
        )}

        {/* ================= REFERENCES PAGE ================= */}
        {reportData?.response?.references?.data_sources && reportData.response.references.data_sources.length > 0 && (
          <table cellPadding={0} cellSpacing={0} style={pageStyle}>
            <tbody>
              <tr>
                <td style={{ border: "none", verticalAlign: "top", padding: "40px" }}>
                  <div
                    contentEditable={isEditMode}
                    suppressContentEditableWarning
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "#1e40af",
                      marginBottom: "24px",
                      outline: isEditMode ? '2px dashed #f97316' : 'none',
                      padding: isEditMode ? '4px' : '0',
                      cursor: isEditMode ? 'text' : 'default'
                    }}
                  >
                    Relevant Sources
                  </div>

                  <div style={{ 
                    columnCount: 1,
                    columnGap: "0px"
                  }}>
                    {reportData.response.references.data_sources.map((source: any, index: number) => (
                      <div 
                        key={index} 
                        style={{ 
                          breakInside: 'avoid',
                          marginBottom: '20px',
                          fontSize: '12px',
                          lineHeight: '1.6',
                          borderBottom: '1px solid #e5e7eb',
                          paddingBottom: '16px',
                          position: 'relative'
                        }}
                      >
                        <div 
                          contentEditable={isEditMode}
                          suppressContentEditableWarning
                          style={{ 
                            fontWeight: 600, 
                            color: '#1e40af', 
                            marginBottom: '6px',
                            outline: isEditMode ? '1px dashed #f97316' : 'none',
                            padding: isEditMode ? '2px' : '0',
                            cursor: isEditMode ? 'text' : 'default'
                          }}
                        >
                           <a href={source.url} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}></a>
                          {index + 1}. {source.title}
                        </div>
                        
                        {source.url && (
                          <div 
                            contentEditable={isEditMode}
                            suppressContentEditableWarning
                            style={{ 
                              color: '#3b82f6', 
                              marginBottom: '4px', 
                              wordBreak: 'break-all',
                              outline: isEditMode ? '1px dashed #f97316' : 'none',
                              padding: isEditMode ? '2px' : '0',
                              cursor: isEditMode ? 'text' : 'default'
                            }}
                          >
                            <a href={source.url} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                              {source.url}
                            </a>
                          </div>
                        )}
                        
                        {/* {source.summary && (
                          <div 
                            contentEditable={isEditMode}
                            suppressContentEditableWarning
                            style={{ 
                              color: '#4b5563', 
                              marginTop: '8px', 
                              textAlign: 'justify',
                              outline: isEditMode ? '1px dashed #f97316' : 'none',
                              padding: isEditMode ? '2px' : '0',
                              cursor: isEditMode ? 'text' : 'default'
                            }}
                          >
                            {source.summary}
                          </div>
                        )}
                        
                        {source.reliability_score && (
                          <div style={{ marginTop: '6px', fontSize: '11px', color: '#6b7280' }}>
                            Reliability Score: {(source.reliability_score * 100).toFixed(0)}%
                          </div>
                        )} */}

                        {isEditMode && (
                          <button
                            className="delete-button"
                            onClick={() => {
                              setReportData((prev: any) => {
                                const updated = { ...prev };
                                updated.response.references.data_sources.splice(index, 1);
                                return updated;
                              });
                            }}
                            style={{
                              position: 'absolute',
                              top: '0',
                              right: '0',
                              background: '#dc2626',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '4px 8px',
                              fontSize: '11px',
                              cursor: 'pointer'
                            }}
                          >
                            🗑️ Delete
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        )}

        {/* ================= FOOTER PAGE ================= */}
        <table cellPadding={0} cellSpacing={0} style={pageStyle}>
          <tbody>
            <tr style={{ width: 794, height: 1123 }}>
              <td style={{ backgroundColor: '#f0f0f0', padding: '30px 20px', width: 794, verticalAlign: "bottom" }}>
                <p 
                  contentEditable={isEditMode}
                  suppressContentEditableWarning
                  onBlur={handleFooterTextChange}
                  style={{
                    fontSize: '14px',
                    lineHeight: '20px',
                    marginBottom: '20px',
                    marginTop: '0',
                    color: '#3c3c3c',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    outline: isEditMode ? '2px dashed #f97316' : 'none',
                    padding: isEditMode ? '8px' : '0',
                    cursor: isEditMode ? 'text' : 'default'
                  }}
                >
                  {footerText}
                </p>

                <table cellPadding="0" cellSpacing="0" width="100%" style={{ border: "none" }}>
                  <tbody style={{ border: "none" }}>
                    <tr style={{ border: "none" }}>
                      <td align="left" valign="middle" style={{ border: "none" }}>
                        <a href="https://www.broadridge.com/" target="_blank" rel="noopener noreferrer">
                          <img
                            src="https://www.broadridge.com/_Static-Assets/images/brodridgeLogo.svg"
                            alt="Broadridge"
                            height="30"
                            style={{ display: 'block', border: '0' }}
                          />
                        </a>
                      </td>
                      <td 
                        contentEditable={isEditMode}
                        suppressContentEditableWarning
                        onBlur={(e) => setFooterReadyForNextLabel(e.currentTarget.textContent || '')}
                        align="right" 
                        valign="middle" 
                        style={{
                          border: "none",
                          fontSize: '22px',
                          fontWeight: '400',
                          color: '#000c36',
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          outline: isEditMode ? '2px dashed #f97316' : 'none',
                          padding: isEditMode ? '4px' : '0',
                          cursor: isEditMode ? 'text' : 'default'
                        }}
                      >
                        {footerReadyForNextLabel}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Report;
